export const TitledContent = ({ title = "", actions = [], children }) => {
    return <>
        <div className="d-sm-flex justify-content-between align-items-center mb-4 mt-2">
            <h3 className="text-dark mb-0">{title}</h3>
            <div>{actions}</div>
        </div>
        {children}
    </>
}
export default TitledContent;